/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default props => (
    <SvgIcon {...props}>
        <path d="m12 8-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z" />
    </SvgIcon>
);
